import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sonnet-four',
  templateUrl: './sonnet-four.component.html',
  styleUrls: ['./sonnet-four.component.scss']
})
export class SonnetFourComponent {
  constructor(public dialogRef: MatDialogRef<SonnetFourComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
